import { getQueryStringArgs } from './query-string';

const { id,code } = getQueryStringArgs(location.search);

export { id,code };
